(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("requestPasswordReset", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/public/requestPasswordResetView.html",
            controllerAs: "vm",
            bindToController: true,
            controller: ["publicResource", "messageService", "frameworkService", RequestPasswordResetCtrl]
        };
        function RequestPasswordResetCtrl(publicResource, messageService, frameworkService) {
            var vm = this;
            vm.showErrors = false;
            vm.sending = false;
            vm.frameworkData = frameworkService.data;
            vm.submit = function (isValid) {
                vm.sending = true;
                if (isValid) {
                    var model = {
                        tenantId: vm.frameworkData.tenant.id,
                        userName: vm.userName
                    };
                    publicResource.requestPasswordReset(model, function () {
                        messageService.success("public.requestPasswordReset.success");
                        vm.sending = false;
                    }, function () {
                        vm.sending = false;
                        messageService.error("common.genericError");
                    });
                }
                else {
                    vm.showErrors = true;
                    vm.sending = false;
                }
            };
        }
    });
}());
